<template>
  <div class="mt-2 w-full px-10">
    <div class="mt-10 text-2xl mx-auto">
      <h1 class="w-full mx-auto uppercase">
        {{$t('lesson.classrooms')}}
      </h1>
    </div>
    <div class="flex flex-col mt-2" v-if="classrooms.length">
      <classroom-row
        v-for="classroom in classrooms"
        :key="classroom.id"
        class="mb-2"
        :classroom="classroom"
        :isTeacher="false" />
    </div>
    <div v-else> {{$t('lesson.no-class')}} <br>
      {{$t('lesson.discover')}}
      <router-link to="/teachers" class="font-bold hover:text-gray-500">
        {{$t('lesson.teachers')}}
      </router-link>
      {{$t('lesson.start')}}
    </div>
  </div>
</template>

<script>
import { getStudentClassrooms } from '@/services/StudentService';
import { mapGetters } from 'vuex';
import ClassroomRow from '@/components/graphics/ClassroomRow.vue';

export default {
  components: { ClassroomRow },
  data() {
    return {
      classrooms: [],
    };
  },

  computed: {
    ...mapGetters({
      student: 'auth/student',
    }),
  },

  created() {
    getStudentClassrooms(this.student.id).then(({ data }) => {
      this.classrooms = data;
    });
  },
};
</script>
